import axios from 'axios'
import config from '../../config'
import { Dispatch } from 'redux'
import { ReportQuestionActionType } from '../action-types'
import { ReportQuestionInterface } from '../../ts/interfaces/ReportQuestionInterface'

const { apiUrl } = config

const setReportQuestionLoading = () => ({
    type: ReportQuestionActionType.SET_REPORT_QUESTION_LOADING,
})

export const getPartnerReportQuestions =
    (partnerId: number, organizationId: number) =>
    async (dispatch: Dispatch) => {
        dispatch(setReportQuestionLoading())

        const res = await axios.get(
            `${apiUrl}/v1/partners/${partnerId}/organizations/${organizationId}/questions`
        )

        if (res.status !== 200) {
            return false
        }

        dispatch({
            type: ReportQuestionActionType.GET_REPORT_QUESTIONS,
            payload: res.data.data,
        })

        return true
    }

export const addPartnerReportQuestion =
    (partnerId: number, organizationId: number, payload: ReportQuestionInterface) =>
    async (dispatch: Dispatch) => {
        dispatch(setReportQuestionLoading())

        const res = await axios.post(
            `${apiUrl}/v1/partners/${partnerId}/organizations/${organizationId}/questions`,
            payload
        )

        if (res.status !== 200) {
            return false
        }

        dispatch({
            type: ReportQuestionActionType.ADD_REPORT_QUESTION,
            payload: res.data.data,
        })

        return true
    }

export const putPartnerReportQuestion =
    (
        partnerId: number,
        organizationId: number,
        questionItem: ReportQuestionInterface,
        payload: any
    ) =>
    async (dispatch: Dispatch) => {
        dispatch(setReportQuestionLoading())

        const res = await axios.put(
            `${apiUrl}/v1/partners/${partnerId}/organizations/${organizationId}/questions/${questionItem.id}`,
            payload
        )

        if (res.status !== 200) {
            return false
        }

        const questionPayload = {
            oldId: questionItem.id,
            newQuestion: res.data.data,
        }

        dispatch({
            type: ReportQuestionActionType.PUT_REPORT_QUESTION,
            payload: questionPayload,
        })

        return true
    }

export const deletePartnerReportQuestion =
    (partnerId: number, organizationId: number, questionItem: ReportQuestionInterface) =>
    async (dispatch: Dispatch) => {
        dispatch(setReportQuestionLoading())

        const res = await axios.delete(
            `${apiUrl}/v1/partners/${partnerId}/organizations/${organizationId}/questions/${questionItem.id}`
        )

        if (res.status !== 200) {
            return false
        }

        dispatch({
            type: ReportQuestionActionType.DELETE_REPORT_QUESTION,
            payload: questionItem.id,
        })

        return true
    }
